/** Iter 632 — customer wizard · expired card (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import { Clock } from "lucide-react";

export default function ExpiredCard({ w }) {
  const { recoverAttempts, setExpired, recoverSession } = w;
  return (
    <div className="rounded-2xl bg-amber-50 border border-amber-200 p-5 text-center" data-testid="engage-session-expired">
      <Clock className="w-6 h-6 mx-auto text-amber-600" />
      <div className="mt-2 font-bold text-slate-900">Session expired</div>
      <p className="mt-1 text-sm text-slate-600">Scan the store QR at the till again — or start a fresh session right here.</p>
      {/* Iter-326 — never a true dead-end: manual retry resets the
          auto-recovery budget and creates a new session in place. */}
      <button
        type="button"
        data-testid="engage-expired-restart"
        onClick={() => {
          recoverAttempts.current = 0;
          setExpired(false);
          recoverSession();
        }}
        className="mt-3 inline-flex items-center justify-center rounded-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-bold px-6 py-2.5 transition-colors"
      >
        Start a fresh session
      </button>
    </div>
  );
}
